// extracted by mini-css-extract-plugin
module.exports = {"title":"OrderItemDetails_title__bRr8p","btnViewProject":"OrderItemDetails_btnViewProject__mdYMW"};